module.exports = __webpack_public_path__ + "static/media/011-call-center-1.defd1176.svg";